import React from 'react';
import { SimpleFrame } from "../../frame/SimpleFrame";
import { SmallUnderline } from "../../styles/components/SmallUnderline";
import { Button } from "../button/Button";
import { ItemGroup } from "../item-group/ItemGroup";
import { GridLayout } from "../layout/GridLayout";
import { NewsCard } from "../item/NewsCard";
import { connect } from 'react-redux';
import {push} from "react-router-redux";
import { isoDateFormat } from "../../util/DateFormat";
import { getFeaturedImage} from "../../util/FeaturedImage";

class NewsListSectionContainer extends React.Component {

  constructor(props) {
    super(props);

    this.loadNews = this.loadNews.bind(this);

    this.state = {
      news: []
    };
  }

  componentDidMount() {
    this.loadNews(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadNews(nextProps);
  }

  loadNews(props) {

    let news = props.newsList.slice(0,4).map( story => {

      return {
        title: story.title && story.title.rendered,
        content: story.excerpt && story.excerpt.rendered,
        date: isoDateFormat(story.date),
        image: getFeaturedImage(story, 'medium_large', null),
        type: Array.isArray(story.categories) && story.categories[0].name,
        slug: story.slug
      }
    });

    this.setState({news});
  }

  render(){
    return (
      <SimpleFrame tag="section"
                   windowClass="news-section simple-frame"
                   color={ this.props.bgColor || "white" }
                   title={
                     <SmallUnderline align="center">
                       <h2>Latest News</h2>
                     </SmallUnderline>
                   }
                   footer={
                     <div className="news-footer">
                       <Button size={'sm'} onClick={() => this.props.changeLocation('/news')}>More News</Button>
                     </div>
                   }>
        <ItemGroup layout={ GridLayout }
                   layoutAttributes={{ noGutters: true, single_row: true }}
                   item={ NewsCard } data={this.state.news}/>
      </SimpleFrame>
    );
  }
}

export const NewsListSection = connect(
  state => ({
    wpapi: state.WPAPI.instance,
    newsList: ( state.resolve.data && state.resolve.data.news_list ) || []
  }),
  dispatch => ({
    changeLocation: location => dispatch(push(location)),
  })
)(NewsListSectionContainer);



// WEBPACK FOOTER //
// ./src/components/news/NewsListSection.js